import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenJobID'
})
export class ShortenJobIdPipe implements PipeTransform {

  transform(id: any): any {
    if (!id) {
      return '';
    }

    if (id.length > 6) {
      const startIndex =  id.length - 6;

      return id.substr(startIndex);
    }
    return id;
  }

}
